import { createFileRoute } from '@tanstack/react-router';

import { Platforms } from '@mint-sdk/api-bff';
import { Metadata } from '@mint-sdk/api-mdm';

export const Route = createFileRoute(
  '/_secured/external-data/integrations/$integration/connections',
)({
  loader: async ({ context, params }) => {
    const isSettingsV2 = await context.isFlagEnabled(
      '@mint/arm',
      'settingsMint2',
    );
    const i18n = await context.getInstance('i18n', '@mint/routing');

    let platformLabel = '';

    if (isSettingsV2) {
      const [, profile] = await context.serviceLocator.getInstance('profile');
      const companyId = profile?.getProfileData()?.profile.company.id;
      const platformsMint2 = await context
        .prefetchQuery(
          Metadata.getContextMetadataQueryOptions({
            params: {
              fieldUrnIds: ['platform_v2'],
              companyId,
              context: 'integration',
            },
          }),
        )
        .catch(() => undefined);

      platformLabel =
        platformsMint2?.[
          Object.keys(platformsMint2).find((key) =>
            key.includes('platform_v2'),
          ) ?? ''
        ]?.options.find((option) => option.value.includes(params.integration))
          ?.label ?? '';
    } else {
      const platforms = isSettingsV2
        ? []
        : await context
            .prefetchQuery({
              ...Platforms.listQueryOptions({
                params: { excludeDeleted: true, excludeNotIntegrated: false },
              }),
              staleTime: 1000 * 60 * 5,
            })
            .catch(() => undefined);

      platformLabel =
        platforms?.find((platform) => platform.platform === params.integration)
          ?.label ?? '';
    }

    const title = i18n.t('Connections - {{platform}} | MINT', {
      platform: platformLabel || params.integration,
    });

    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
